import React from 'react';
import HeroProductCard from './hero-product-card';
import SectionHeading from '../common/section-heading-component';
import { AI_POWERED_FINANCE_HERO_DATA } from './constants';

const AIPoweredFinanceHeroSection: React.FC = () => {
  return (
    <div
      className="pb-24 sm:pb-8 md:pb-16 bg-right-top bg-no-repeat"
      style={{
        backgroundImage:
          'url("https://assets.clear.in/cleartax/images/1725535759_righttop.svg")',
        backgroundSize: '17%',
      }}
    >
      <section className="wg-container mx-auto px-4">
        <SectionHeading
          heading={AI_POWERED_FINANCE_HERO_DATA.heading}
          classname="text-center mx-auto sm:text-left pt-8 mt-1"
        />

        <div className="flex sm:flex-col pt-8 justify-center px-6 sm:px-0 sm:items-center gap-16">
          {AI_POWERED_FINANCE_HERO_DATA.productCards.map((card) => (
            <HeroProductCard key={card.id} card={card} />
          ))}
        </div>
      </section>
    </div>
  );
};

export default AIPoweredFinanceHeroSection;
